import { AxiosResponse } from 'axios'
import { API } from '../../../../common/api'
import { cloudfaasServiceUrl } from '../../../../common/utils/constants'
import {
  CreateFTRAssessmentRequest,
  CreateFTRAssessmentResponse,
  FTRAssessmentFormDetails,
} from '../../../modules/ftr/ftrAssessment/reducer'
import { Answers } from '../../../modules/ftr/questionsList/reducer'

export const fetchAssessmentsList = (
  partnerId: string,
  assessmentName?: string,
  assessmentStatus?: string,
  rowsPerSize = 10,
  pageNumber = 1
) => {
  return API.get(`${cloudfaasServiceUrl}/partners/${partnerId}/assessments`, {
    params: {
      page_number: pageNumber || 1,
      rows_per_size: rowsPerSize,
      ...(assessmentName && { name: assessmentName }),
      ...(assessmentStatus && { assessment_status: assessmentStatus }),
    },
  })
}

export const fetchSectionsList = (partnerId: string) => {
  return API.get(
    `${cloudfaasServiceUrl}/partners/${partnerId}/assessment_types/FTR/sections`
  )
}

export const createFTRAssessment = (
  partnerId: string,
  assessmentData: CreateFTRAssessmentRequest
): Promise<AxiosResponse<CreateFTRAssessmentResponse>> => {
  return API.post(
    `${cloudfaasServiceUrl}/partners/${partnerId}/assessments`,
    assessmentData
  )
}
export const updateFTRAssessment = (
  partnerId: string,
  assessmentId: string,
  assessmentData: CreateFTRAssessmentRequest
) => {
  return API.patch(
    `${cloudfaasServiceUrl}/partners/${partnerId}/assessments/${assessmentId}`,
    assessmentData
  )
}
export const fetchAssessmentById = (
  partnerId: string,
  assessmentId: string
): Promise<AxiosResponse<FTRAssessmentFormDetails>> => {
  return API.get(
    `${cloudfaasServiceUrl}/partners/${partnerId}/assessments/${assessmentId}`
  )
}
export const fetchQuestionsList = (
  partnerId: string,
  sectionId: string,
  assessmentId: string
) => {
  return API.get(
    `${cloudfaasServiceUrl}/partners/${partnerId}/assessments/${assessmentId}/sections/${sectionId}/questions`
  )
}

export const getAssessmentReport = (
  partnerId: string,
  assessmentId: string
) => {
  return API.get(
    `${cloudfaasServiceUrl}/partners/${partnerId}/assessments/${assessmentId}/reports`
  )
}

export const getCISAssessmentReport = (
  partnerId: string,
  assessmentId: string
) => {
  return API.get(
    `${cloudfaasServiceUrl}/partners/${partnerId}/assessments/${assessmentId}/cis-checks/report`
  )
}
export const deleteWorkload = (partnerId: string, assessmentId: string) => {
  return API.delete(
    `${cloudfaasServiceUrl}/partners/${partnerId}/assessments/${assessmentId}`
  )
}

export const AddAnswer = (
  partnerId: string,
  questionId: string,
  answerData: Answers
) => {
  return API.post(
    `${cloudfaasServiceUrl}/partners/${partnerId}/questions/${questionId}/answers`,
    answerData
  )
}

export const updateAnswer = (
  partnerId: string,
  answerId: string,
  answerData: Answers
) =>
  API.patch(
    `${cloudfaasServiceUrl}/partners/${partnerId}/answers/${answerId}`,
    answerData
  )

export const getFindingsList = (
  partnerId: string,
  assessmentId: string,
  limit = 10,
  status?: string[],
  sectionIds?: string[],
  questionIdRefs?: string[],
  subSectionIds?: string[],
  region?: string[],
  awsAccountId?: string[],
  paginationToken?: string,
  downloadReport?: boolean
) => {
  const params: Record<string, any> = {
    limit: limit,
    ...(paginationToken && { pagination_token: paginationToken }),
    ...(downloadReport && { download_report: downloadReport }),
  }

  // Handle arrays for multiple values

  if (status?.length) {
    params['status'] = status
  }
  if (region?.length) {
    params['regions'] = region
  }
  if (awsAccountId?.length) {
    params['aws_accounts'] = awsAccountId
  }
  if (questionIdRefs?.length) {
    params['question_id_refs'] = questionIdRefs
  }
  if (subSectionIds?.length) {
    params['sub_section_ids'] = subSectionIds
  }
  if (sectionIds?.length) {
    params['section_ids'] = sectionIds
  }

  params['assessment_type'] = 'FTR'

  return API.get(
    `${cloudfaasServiceUrl}/partners/${partnerId}/assessments/${assessmentId}/checks/findings`,
    {
      params,
      paramsSerializer: params => {
        return Object.entries(params)
          .reduce((acc, [key, value]) => {
            if (Array.isArray(value)) {
              value.forEach(v => acc.push(`${key}=${v}`))
            } else {
              acc.push(`${key}=${value}`)
            }
            return acc
          }, [] as string[])
          .join('&')
      },
    }
  )
}

export const getFTRFindingsSummary = (
  partnerId: string,
  assessmentId: string,
  filter?: string,
  filterId?: string
) => {
  return API.get(
    `${cloudfaasServiceUrl}/partners/${partnerId}/assessments/${assessmentId}/checks/summary`,
    {
      params: {
        ...(filter && { filter_level: filter }),
        ...(filterId && { filter_id: filterId }),
      },
    }
  )
}

export const refreshFindings = (partnerId: string, assessmentId: string) => {
  return API.post(
    `${cloudfaasServiceUrl}/partners/${partnerId}/assessments/${assessmentId}/checks/refresh`
  )
}

export const suppressFinding = (
  partnerId: string,
  assessmentId: string,
  findings?: string[],
  action?: string
) => {
  return API.post(
    `${cloudfaasServiceUrl}/partners/${partnerId}/assessments/${assessmentId}/checks/findings/suppress`,
    {
      finding_ids: findings,
      action: action,
      assessment_type: 'FTR',
    }
  )
}
